import React, { useContext, useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import PaquetesIncluidos from "./PaquetesIncluidos";
import TotalAPagar from "./TotalAPagar";
import AvisoProductoDigital from "./AvisoProductoDigital";
import FormCodigoDescuento from "./FormCodigoDescuento";
import UserContext from "@context/User/UserContext";
import { getPricesRenovacion } from "@helpers/httpRequests/httpRequestsPagos/httpRequestsPagos";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

const Body = () => {
	const stripePromiseLive = loadStripe("pk_live_51IE0gOFjRsT0gjxgx2Phi43JYhjKNMrsWrrUMo5Fp4lew8xWwGZtxUUscs1XPG3QtflOi8KQnlm7c4Wd9njeXUrR00qKYiy86I")
	const stripePromiseTest = loadStripe("pk_test_51IE0gOFjRsT0gjxg9MtRKLzHSYaYxKJHiJiryN4OqfytvSexyDFBUvuf2MZfL4A3qecujZ4Os14GAlyjLD570jII00KYH97ErX")

	const { contextValue, setContextValue } = useContext(UserContext);

	const {usuarioLogeado} = contextValue;

	const {idCodigoRegion} = usuarioLogeado;

	const [precios, setPrecios] = useState({
		contado: {
			monto: 0,
		},
		msi: {
			monto: 0,
			planes: [],
		},
		credito: { precioTotal: 0, pagoInicial: 0, pagoQuincenal: 0, totalPagosQuincenales: 0 },
	});

	const [codigoAplicado, setCodigoAplicado] = useState(false);

	const [codigoDescuento, setCodigoDescuento] = useState("");

	//TODO: Aplicar la validacion para recuperar los precios de renovacion para latam.

	const consultarPreciosRenovacion = async () => {
		try {
			const precios = await getPricesRenovacion();

			// setContextValue({
			// 	...contextValue,
			// 	renovacion: {
			// 		precios,
			// 	},
			// });

			setPrecios(precios);
		} catch (error) {
			console.log("Error al consultar los precios de la renovacion: ", error);
		}
	};

	useEffect(() => {
		if (precios.contado.monto === 0) {
			consultarPreciosRenovacion();
		}
	}, [precios]);

	return (
		<>
			<Row className="detalle-compra-pricing">
				<PaquetesIncluidos codigoAplicado={codigoAplicado} />

				<TotalAPagar codigoAplicado={codigoAplicado} codigoDescuento={codigoDescuento} precios={precios} />
			</Row>

			{/* <Row className="detalle-compra-pricing pb-4 pb-lg-5">
				<AvisoProductoDigital />
				

			</Row> */}
			
			<Row className="detalle-compra-pricing pb-4 pb-lg-5">
				{/* <Elements stripe={stripePromiseTest} > */}
						<FormCodigoDescuento
							precios={precios}
							states={{
								stateCodigoAplicado: {
									codigoAplicado,
									setCodigoAplicado,
								},
								stateCodigoDescuento: {
									codigoDescuento,
									setCodigoDescuento,
								},
								// statePreciosXCodigo	: {
								// 	preciosXCodigo,
								// 	setPreciosXCodigo,
								// }
							}}
						/>
				{/* </Elements> */}
			</Row>
		</>
	);
};

export default Body;
